$(function () {
    var numberOfShownSpeakers = 52;

    var speakersList = $('#speakers-list');
    var loadMoreSpeakersButton = $('#load-more-speakers-btn');

    window.loadMoreSpeakers = function () {
        $.get(window.getLocation('speakers'), {
            offset: numberOfShownSpeakers
        }, function (data) {
            numberOfShownSpeakers += 12;
            loadMoreSpeakersButton.remove();
            speakersList.append(data);
            loadMoreSpeakersButton = $('#load-more-speakers-btn');
        })
    }
});
